import { RadioGroup } from '@/components/RadioGroup';
import {
    ESelfAssessedCreditHistory,
    selectSelfAssessedCreditHistory,
    setSelfAssessedCreditHistory,
} from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { useFieldCopy } from '@/copy';
import { getEnumValueFromString } from '@/utils/getEnumValueFromString';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'SelfAssessedCredit';

export function SelfAssessedCredit({
    baseId,
    showErrors,
}: IProps): JSX.Element {
    // ***** Redux *****
    const fields = useFieldCopy();
    const currentState = useAppSelector(selectSelfAssessedCreditHistory);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean | undefined): void {
        dispatch(
            setSelfAssessedCreditHistory(
                getEnumValueFromString(ESelfAssessedCreditHistory, value)
            )
        );
    }

    // ***** Render *****
    const options = [
        {
            label: 'Great',
            value: ESelfAssessedCreditHistory.GREAT,
            id: `${baseId}-button-selfAssessedCredit-great`,
        },
        {
            label: 'Decent',
            value: ESelfAssessedCreditHistory.DECENT,
            id: `${baseId}-button-selfAssessedCredit-decent`,
        },
        {
            label: 'Poor',
            value: ESelfAssessedCreditHistory.POOR,
            id: `${baseId}-button-selfAssessedCredit-poor`,
        },
    ];
    return (
        // The RadioGroup inside already carries the screen's field rhythm;
        // this added 8px more on top of it.
        <div data-testid={testId} className='w-full'>
            <RadioGroup
                title={fields.creditHistory}
                showErrors={showErrors}
                onChange={handleChange}
                options={options}
                value={currentState}
                tooltipContent="An estimate is fine. Your final offer is based on the lender's own credit check."
            />
        </div>
    );
}
